import root from '../root';

/**
 * @public
 * Determines if the entry parameter is a DOM Element.
 *
 * @param  {any} obj: the object to test
 * @return {Boolean}
 */
export default function isDOM(obj) {
  if ('HTMLElement' in root) return !!(obj && obj instanceof HTMLElement);
  return !!(obj && typeof obj === 'object' && obj.nodeType === 1 && obj.nodeName);
}
